export const BASE_CARD_CLASSNAMES = {
  card: 'w-full',
  title: 'h-[30px]',
  content: 'h-[calc(100%-30px)] rounded-lg overflow-y-hidden flex flex-row justify-between items-center p-6',
} as const;

export const PUBLISH_STATUS = [
  {
    value: '0',
    label: 'Not published',
  },
  {
    value: '10',
    label: 'Published',
  },
] as const;

export enum MANAGEMENT_ROLE {
  DMAdmin = 'dm_admin',
  Admin = 'admin',
  Member = 'member',
}
